import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';
import './kree.scss';
import DisplayList from '../app/components/DisplayList';

class Kree {
  constructor() {
    this.layout();
    // initButtons();
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('kree-template'), {}));

    Localizr.parseObjectList(settings.sections.kree.items);

    DisplayList.create(
        '<img src="{{image}}" alt="{{alt}}">',
        settings.sections.kree.gallery.filter((img) => img.visible),
        document.querySelector('.kree-thumbs')
    );
  }

  initButtons() {}

  preenter() {}

  enter() {
    // trackPageView('About');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {}
}

export default Kree;
